import * as React from "react"

import Header from "./header"
import Footer from "./footer"
import useSiteMetadata from "../hooks/useSiteMetadata";

const Layout = ({ children }) => {
  const metadata = useSiteMetadata();

  return (
    <>
      <Header siteTitle={metadata?.title || `Title`} />
      <div className="bg-primary flow-root">
        <main>{children}</main>
        <Footer siteTitle={metadata?.title || `Title`} />
      </div>
    </>
  )
}

export default Layout
